<div class="d-flex align-items-center justify-content-center vh-100">
    <div class="text-center">
        <h1 class="display-1 fw-bold">401 - Unauthorized</h1>
        <p class="fs-3"> <span class="text-danger">Opps!</span> You are not authorized.</p>
        <p class="lead">
            It seems like you don't have permission to view this page. <a href="#" (click)="logout($event)">Go to Home..</a>
          </p>
    </div>
</div>